import { WebScriptCommands } from "@whatslly/commons/webScriptCommands";
import { webScriptBackend } from "@whatslly/instant-messaging/webScriptBackend";
import { useEffect, useState } from "react";

export const useInjectedComponent = (initialState: { widgetOpen: boolean }) => {
  const [isWidgetOpen, setIsWidgetOpen] = useState(initialState.widgetOpen);

  useEffect(() => {
    const unsubscribe = webScriptBackend
      .on(WebScriptCommands.OPEN_WIDGET, () => setIsWidgetOpen(true))
      .on(WebScriptCommands.CLOSE_WIDGET, () => setIsWidgetOpen(false));
    return () => unsubscribe();
  }, []);

  return { isWidgetOpen };
};
